import { createSlice } from "@reduxjs/toolkit";
import RadyolojiKabulAramaKriterleri from "src/models/RadyolojiModul/RadyolojiKabulAramaKriterleri";
import VwRadyolojiKabulislemlerDTO from "src/models/RadyolojiModul/VwRadyolojiKabulislemlerDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { helper } from "src/utils/helper";

export class RadBekleyenOzetModel{
    adSoyad: string;
    kimlikId: number;
    kimlikNo: string;
    organizasyonId: number;
    organizasyonAdi: string;
    raportiptanimAdi: string;
    raportiptanimId: number;
    id: number;
    muracaatId: number;
}
interface IRadyolojiKabulState {
    searchHandler: boolean;
    searchBekleyenTalepHandler: boolean;
    radBekleyenOzetList: Array<RadBekleyenOzetModel>;
    radBekleyenOzetActiveRow: RadBekleyenOzetModel;
    radyolojiKabulListe:Array<VwRadyolojiKabulislemlerDTO>;
    radyolojiKabulBekleyenListe:Array<VwRadyolojiKabulislemlerDTO>;
    radyolojiKabulActiveRow:VwRadyolojiKabulislemlerDTO;
    aramaKriterleri:RadyolojiKabulAramaKriterleri;
    bekleyenTaleplerAramaKriterleri:RadyolojiKabulAramaKriterleri;
    bekleyenTaleplerDialog:boolean,
    redDialog:boolean,
    bekleyenSatirSecim:boolean,
    kabulSelectionIds: Array<VwRadyolojiKabulislemlerDTO>;
};

export const RadyolojiKabulSlice = createSlice<IRadyolojiKabulState, MapReducerPayloads<IRadyolojiKabulState, {
    setSearchHandler: boolean;
    setSearchBekleyenTalepHandler: boolean;
    setRadBekleyenOzetListe:Array<RadBekleyenOzetModel>;
    setRadBekleyenOzetActiveRow: RadBekleyenOzetModel;
    setRadyolojiKabulListe:Array<VwRadyolojiKabulislemlerDTO>;
    setRadyolojiKabulBekleyenListe:Array<VwRadyolojiKabulislemlerDTO>;
    setRadyolojiKabulActiveRow:VwRadyolojiKabulislemlerDTO;
    setAramaKriterleri:RadyolojiKabulAramaKriterleri;
    setBekleyenTaleplerAramaKriterleri:RadyolojiKabulAramaKriterleri;
    setBekleyenTaleplerDialog:boolean;
    setRedDialog:boolean;
    setBekleyenSatirSecim:boolean;
    setKabulSelectionIds: Array<VwRadyolojiKabulislemlerDTO>;
}>>({
    name: "radyolojiKabul",
    initialState: {
        searchHandler: false,
        searchBekleyenTalepHandler: false,
        radBekleyenOzetList: [],
        radBekleyenOzetActiveRow: new RadBekleyenOzetModel(),
        radyolojiKabulListe:[],
        radyolojiKabulBekleyenListe:[],
        radyolojiKabulActiveRow : new VwRadyolojiKabulislemlerDTO(),
        aramaKriterleri: {
            ...new RadyolojiKabulAramaKriterleri(),
            baslangicTarih:helper.datetimeToday(),
            bitisTarih:helper.datetimeToday(),
        },
        bekleyenTaleplerAramaKriterleri: {
            ...new RadyolojiKabulAramaKriterleri(),
            baslangicTarih:helper.datetimeToday(),
            bitisTarih:helper.datetimeToday(),
        },
        bekleyenTaleplerDialog:false,
        redDialog:false,
        bekleyenSatirSecim:false,
        kabulSelectionIds: new Array<VwRadyolojiKabulislemlerDTO>(),
    },
    reducers: {
        setSearchHandler: (state:IRadyolojiKabulState, action) => {
            state.searchHandler = action.payload
        },
        setSearchBekleyenTalepHandler: (state:IRadyolojiKabulState, action) => {
            state.searchBekleyenTalepHandler = action.payload
        },
        setRadyolojiKabulListe: (state:IRadyolojiKabulState, action) => {
            state.radyolojiKabulListe = action.payload
        },
        setRadyolojiKabulBekleyenListe: (state:IRadyolojiKabulState, action) => {
            state.radyolojiKabulBekleyenListe = action.payload
        },
        setAramaKriterleri: (state:IRadyolojiKabulState, action) => {
            state.aramaKriterleri = action.payload
        },
        setBekleyenTaleplerAramaKriterleri: (state:IRadyolojiKabulState, action) => {
            state.bekleyenTaleplerAramaKriterleri = action.payload
        },
        setBekleyenTaleplerDialog: (state:IRadyolojiKabulState, action) => {
            state.bekleyenTaleplerDialog = action.payload
        },
        setRadyolojiKabulActiveRow: (state:IRadyolojiKabulState, action) => {
            state.radyolojiKabulActiveRow = action.payload
        },
        setRedDialog: (state:IRadyolojiKabulState, action) => {
            state.redDialog = action.payload
        },
        setBekleyenSatirSecim: (state:IRadyolojiKabulState, action) => {
            state.bekleyenSatirSecim = action.payload
        },
        setRadBekleyenOzetListe: (state, action) => {
            state.radBekleyenOzetList = action.payload
        },
        setRadBekleyenOzetActiveRow: (state, action) => {
            state.radBekleyenOzetActiveRow = action.payload
        },
        setKabulSelectionIds: (state, action) => {
            state.kabulSelectionIds = action.payload
        }
    }
});